// Vorbelegungen für Rechnungs-/Angebotspositionen (manuell editierbar).
export const POSITION_PRESETS = {
  fahrtpauschale: {
    name: "Fahrtkostenpauschale",
    description: "An- und Abfahrt zum Einsatzort",
    quantity: 1,
    unit_name: "Fahrt",
    unit_price_net: 0,
  },
  km_pauschale: {
    name: "Kilometerpauschale",
    description: "Gefahrene Kilometer (An- und Abfahrt)",
    quantity: 0,
    unit_name: "km",
    unit_price_net: 0.6,
  },
  uebernachtung: {
    name: "Übernachtung",
    description: "",
    quantity: 1,
    unit_name: "Nacht",
    unit_price_net: 0,
  },
  material: {
    name: "Material / Einkauf",
    description: "",
    quantity: 1,
    unit_name: "Pauschal",
    unit_price_net: 0,
  },
};

// Übernimmt einen Preset nur, wenn die Position noch unangetastet ist.
export function applyTypePreset(currentItem, typeKey, taxRate) {
  const preset = POSITION_PRESETS[typeKey];
  if (!preset) return { type_key: typeKey };
  const untouched =
    !currentItem?.name ||
    String(currentItem.name).trim() === "" ||
    (Number(currentItem.unit_price_net) === 0 && Number(currentItem.quantity) === 1);
  if (!untouched) return { type_key: typeKey };
  return {
    type_key: typeKey,
    ...preset,
    ...(taxRate != null ? { tax_rate: taxRate } : {}),
  };
}
